(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamplayers/assets/javascripts/views/statteamplayers.js') >= 0) return;  svs.modules.push('/components/statistics/teamplayers/assets/javascripts/views/statteamplayers.js'); 

(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatTeamPlayers = Backbone.View.extend({
    tagName: 'div',
    SPORT_HOCKEY: 'sport-hockey',
    classId: 'StatTeamPlayers',
    events: {},
    initialize: function(options) {
      if (!options.params.teamId) {
        return;
      }

      this.options = options;

      this.model = new svs.statistics.models.StatTeamPlayers({
        teamId: this.options.params.teamId,
        currentLeagues: this.options.params.currentLeagues,
        showFlag: this.options.params.showFlag
      });
      this.model.on('change', this.render, this);

      if (
        !!(((svs.statistics || {}).data || {}).teamModels || {}).roster &&
        !svs.statistics.data.teamModels.roster.error
      ) {
        if (
          this.model.get('currentLeagues') &&
          this.model.get('currentLeagues').get('homeLeague')
        ) {
          this.render(options);
        } else {
          this.update();
        }
      } else {
        this.update();
      }
    },
    update: function() {
      var _self = this;
      if (svs.statistics.data.content) {
        this.model.set(svs.statistics.data.content);
        svs.statistics.data.content = null; 
      } else {
        this.model.fetch({
          error: function() {
            _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
            _self.$('.js-statistics-reload').bind('click', function() {
              $(this).unbind('click');
              _self.update();
            });
          }
        });
      }
    },
    retrieveSportById: function(sportId) {
      return new svs.sport.themeLoader().retrieveSportById(sportId);
    },
    featureToggle: function() {
      var currentLeagues = this.model.get('currentLeagues');

      if (
        !_.isObject(currentLeagues) ||
        !_.isArray(currentLeagues.get('leagues'))
      ) {
        return null;
      }
      if (!_.isArray(currentLeagues.get('leagues'))) {
        return null;
      }

      if (currentLeagues.get('leagues').length === 0) return null;

      var sport = currentLeagues.get('leagues')[0].sport;
      if (this.retrieveSportById(sport.id) === this.SPORT_HOCKEY) {
        this.model.set('playerStatsDisabled', true, { silent: true });
        return true;
      }
      return false;
    },
    render: function() {
      if (!this.model) {
        this.$el.html(
          svs.statistics.statistics.templates.nodata({
            renderEmpty: this.options.params.preDraw
          })
        );
        return this;
      }

      this.featureToggle();

      var templateData = this.model.toJSON({ sortedPlayers: true }),
        html = svs.statistics.teamplayers.templates.statteamplayers(
          templateData
        );

      this.$el.html(html);

      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
      return this;
    },
    onDestroy: function() {}
  });
})(Backbone, _, svs);

 })(window);